import { AnimatePresence, motion } from 'framer-motion'
import { withPrefix } from 'gatsby'
import React from 'react'
import { LocationListItem } from '../list-item'
// import { LocationSectionHeader } from '../section-header'


const imageMap = {
    "Atlanta": {
        top: 1,
        bottom: 3,
    },
    "Detroit": {
        top: 2,
        bottom: 4,
    },
    "LA": {
        top: 3,
        bottom: 2
    },
    "Chicago": {
        top: 4,
        bottom: 1
    },
    "Philadelphia": {
        top: 1,
        bottom: 2
    },
    "Buffalo": {
        top: 3,
        bottom: 4
    }
}   



const LocationSection = ({data, city}) => {
    if (city === "All cities") return null;

    return (    
        <AnimatePresence exitBeforeEnter>
            <motion.div
                key={"ls" + city}
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
            >
                <TopImage src={`/images/location-img-${imageMap[city].top}.webp`}/>
                {data.map((item, idx) => {
                    if (idx === Math.floor(data.length / 2)) {
                        return (
                            <React.Fragment key={`lsiz-${idx}-${city}`}>
                                <RowImage src={`/images/location-img-${imageMap[city].bottom}.webp`}/>
                                <LocationListItem key={`loc-${idx}`} data={item}/>
                            </React.Fragment>
                        )
                    }
                    return <LocationListItem key={`loc-${idx}`} data={item}/>
                })}
                {/* <LocationImageFour/> */}
            </motion.div>
        </AnimatePresence>
    )
};

const TopImage = ({src}) => {
    return (
        <div>
            <img src={withPrefix(src)} alt="" />

            <style jsx>{`
                div {
                    position: absolute;
                    top: 70px;
                    right: 100px;
                }

                img {
                    height: 260px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        top: 160px;
                        right: initial;
                        left: 0px;
                        // transform: translateX(50%);
                    }

                    img {
                        height: 150px;
                    }
                }
            `}</style>
        </div>
    )
}

const RowImage = ({src}) => {
    let rand = Math.random() * 75;
    // console.log(rand);
    return (
        <div>
            <img src={withPrefix(src)} alt="" />

            <style jsx>{`
                div {
                    height: 200px;
                    position: relative;
                }

                img {
                    width: 300px;
                    position: absolute;
                    top: -100px;

                    right: ${rand}%;
                    pointer-events: none;
                    z-index: -1;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    img {
                        right: 50%;
                        top: -70px;
                        transform: translateX(50%);
                    }
                }
            `}</style>
        </div>
    )
};




export default LocationSection